// extracted by mini-css-extract-plugin
export var currencyInput = "_k5-1";
export var currencySymbol = "_k5-0";